export class StatementsCsvGetRequest {
  resolutionId: string

  constructor(resolutionId: string) {
    this.resolutionId = resolutionId
  }
}
